import { render, staticRenderFns } from "./TheProject.vue?vue&type=template&id=67da0e81"
import script from "./TheProject.vue?vue&type=script&lang=ts"
export * from "./TheProject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports